import { z } from "zod";

const configSchema = z.object({
  REACT_APP_VERCEL_URL: z.string(),
  REACT_APP_BACKEND_URL: z.string(),
});

export const config = configSchema.parse(process.env);
